import { get } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import { TertiaryHeading } from 'components/Headings';
import Image from 'components/ImageV2';
import { IMAGE_RATIOS, IMAGE_WIDTHS, IMAGE_BG_COLOR } from 'constants/images';
import Theme from 'styles/theme';

const CarouselCard = ({ image, heading, linkUrl, onClick }) => (
  <a className="CarouselCard" href={linkUrl} onClick={onClick}>
    <div className="CarouselCard__image-wrapper">
      <Image
        className="CarouselCard__image"
        src={get(image, 'src')}
        alt={get(image, 'altText')}
        transformations={{ backgroundColor: IMAGE_BG_COLOR }}
        width={IMAGE_WIDTHS.W_600}
        ratio={IMAGE_RATIOS.R_1x1}
      />
    </div>
    <div className="CarouselCard__copy">
      <TertiaryHeading>{heading}</TertiaryHeading>
    </div>
    <style jsx>{`
      .CarouselCard {
        width: 100%;
        height: 100%;
        text-decoration: none;
        box-shadow: 0 8px ${Theme.get('spacing') * 4}px 0 rgba(0, 0, 0, 0.12);
        background-color: ${Theme.get('colors-white')};
      }

      .CarouselCard__image-wrapper {
        width: 100%;
        background-color: ${IMAGE_BG_COLOR};
        position: relative;
        overflow: hidden;
      }

      .CarouselCard__copy {
        padding: ${Theme.get('spacing') * 3}px;
      }
    `}</style>
    <style jsx global>
      {`
        .CarouselCard__copy p.Paragraph {
          margin: ${Theme.get('spacing')}px 0 0;
        }

        .CarouselCard__image {
          transition: transform ${Theme.get('transition-duration-ms')}
            ${Theme.get('transition-timing-ease-out')};
        }
      `}
    </style>
  </a>
);

CarouselCard.propTypes = {
  image: PropTypes.shape({ src: PropTypes.string.isRequired, alt: PropTypes.string }).isRequired,
  heading: PropTypes.string.isRequired,
  linkUrl: PropTypes.string.isRequired,
  onClick: PropTypes.func,
};

CarouselCard.defaultProps = {
  onClick: () => {},
};

export default CarouselCard;
